const VERSION_STORAGE_KEY = 'app-version';

export function getBuildVersion(): string {
  const meta = document.querySelector('meta[name="build-version"]');
  return meta?.getAttribute('content') || 'unknown';
}

export function getStoredVersion(): string | null {
  try {
    return localStorage.getItem(VERSION_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredVersion(version: string): void {
  try {
    localStorage.setItem(VERSION_STORAGE_KEY, version);
  } catch {
    // Silently fail if localStorage is unavailable
  }
}

export function hasVersionChanged(): boolean {
  const currentVersion = getBuildVersion();
  const storedVersion = getStoredVersion();

  if (!storedVersion) {
    setStoredVersion(currentVersion);
    return false;
  }

  return currentVersion !== storedVersion && currentVersion !== '__BUILD_VERSION__';
}

export function updateStoredVersion(): void {
  const currentVersion = getBuildVersion();
  setStoredVersion(currentVersion);
}
